<div class="numeric-textbox-criteria">
  <div class="numeric-textbox-criteria-inner">
    <span class="caption">{{caption}}</span>
    <kendo-numerictextbox #textbox
                          [autoCorrect]="true"
                          [changeValueOnScroll]="false"
                          [format]="format"
                          [min]="minimum"
                          [max]="maximum"
                          [style.width.px]="80"
                          [style.height.px]="24"
                          [spinners]="false"
                          [value]="textBoxValue"
                          (valueChange)="onChange($event)">
    </kendo-numerictextbox>
    <span class="suffix">{{suffix}}</span>
  </div>
</div>
